import { useSelector } from "react-redux";

import "./style.css"

import logo_pro_vide from './../../assets/logo_pro-vide.png'

function Home() {
    const trad = useSelector(state => state.trad);
    const lang = useSelector(state => state.menu.lang);

    return (
        <div className='page page_home'>
            <div className="home_content">
                <h1>Site en maintenance</h1>
                <p className="home_message">
                    Nous travaillons pour améliorer votre expérience.
                    <br />
                    Revenez bientôt !
                </p>
                <div className="contact_info">
                    <p>Nous restons joignables :</p>
                    <a href="tel:+33255996505" className="contact-btn phone-btn">02 55 99 65 05</a>
                    <a href="mailto:contact@pro-vide.eu" className="contact-btn email-btn">contact@pro-vide.eu</a>
                </div>
            </div>
            <div className="logo_pro-vide">
                <img src={logo_pro_vide} alt="Logo Pro-vide" />
                <h2>Pro-vide<span>{trad.sub_title_website ? trad.sub_title_website[lang] : ""}</span></h2>
            </div>
        </div>
    )
}

export default Home;